import React from 'react'
import DetailCard from '../Main/DetailCard'

const value = {
  id: 1,
  heading: "Electric Pallet Truck (Battery Operated)",
  intro : [
    "This Fully automatic Rider type Battery Operated Pallet Truck offers a huge advantage over hand pallet truck with its quick and effortless loading and transporting features, the compact design with easy move in the most confined space and narrow aisle such as in retail stores, small warehouse.",
  ],
  features: [
    "The BOPT incorporates the power-drives system, ensuring smooth and progressive control at all times.",
    "The tiller arm is eay and comforatble to use, with fingertip lift and lower buttons and simple forward/reverse control",
    "Suspension design for drive system ensures a good wheel and ground contact with confortable operation.",
    "Overload Protection through pressure relief valve.",
    "Operators Belly Switch for Operator's Protection.",
    "Jerk Free lifting and lowering.",
    "Cut-off limit at top height to save energy and motor overheating."
  ],
  imageUrl: "/images/electric-pallet-truck.webp"
}

const ElectricPalletTruck = () => {
  return (
  <>
  <DetailCard lists={value}/>
  </>
  )
}

export default ElectricPalletTruck